import React from "react"

import { useActiveJob } from "@/contexts/ActiveJobContext"

interface HeaderProps {
  showJobPosting?: boolean
}

const Header: React.FC<HeaderProps> = ({ showJobPosting = true }) => {
  const { job } = useActiveJob()
  return (
    <header className="relative mb-6 overflow-hidden rounded-lg bg-[#FFBE37] py-8">
      {/* Background image pattern */}
      <div className="absolute inset-0 flex items-center justify-center overflow-hidden rounded-lg opacity-100">
        <img
          src="/images/Hived-outline.svg"
          alt="Background pattern"
          className="min-h-full min-w-full scale-[0.99] object-cover md:scale-[0.50]"
        />
      </div>

      <div className="container relative z-10 mx-auto flex flex-col items-center px-4">
        <img src="/images/Hived-logo.svg" alt="Hived Logo" className="mb-2 h-20 w-20" />

        {/* Title */}
        <h1 className="mb-1 text-xl font-semibold text-black">Application Portal</h1>

        {/* Subtitle - conditionally rendered */}
        {showJobPosting && (
          <h2 className="text-center text-lg font-bold text-black md:text-2xl">{job?.title}</h2>
        )}
      </div>
    </header>
  )
}

export default Header
